import type { CompanyDetails, CompanyDetailsBase } from 'redux/modules/onboarding';
import { encodeUrlParams } from 'utils/url-params';

const baseUrl = 'https://actions.memory.ai'; // Use this for local netlify dev: 'http://localhost:9000';
const url = `${baseUrl}/.netlify/functions/clearbit_api`;
const searchUrl = `${baseUrl}/.netlify/functions/clearbit_search_api`;
const classificationUrl = `${baseUrl}/.netlify/functions/clearbit_classifications_sheet`;

const onboardingApi = {
  getCompanyDetails: async (domain: string, verifyDomain?: boolean): Promise<CompanyDetails> => {
    const queryParams = encodeUrlParams({ domain, verifyDomain });
    const fetchUrl = `${url}${queryParams}`;
    const response = await fetch(fetchUrl);
    return response.json();
  },
  getCompanyClassifications: async () => {
    const response = await fetch(classificationUrl);
    return response.json();
  },
  searchForCompany: async (query: string): Promise<Array<CompanyDetailsBase>> => {
    const queryParams = encodeUrlParams({ query: encodeURIComponent(query) });
    const fetchUrl = `${searchUrl}${queryParams}`;
    const response = await fetch(fetchUrl);
    return response.json();
  },
};

export default onboardingApi;
